import react, { useState } from "react";
import { Typography, TextField, Stack, Button, IconButton, InputAdornment, Grid, Box } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { login } from "state/index";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ email: "", password: "" });

    const handelOnChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    };

    const handleClick = async (event) => {
        event.preventDefault();
        try {
            const res = await login(dispatch, formData.email, formData.password);
            toast.success(res.message);
            localStorage.setItem("token", res.data.auth.accessToken);
            if (res.data.property) {
                localStorage.setItem("propertyId", res.data.property.id);
                localStorage.setItem("propertyName", res.data.property.propertyName);
            }
            navigate("/dashboard", { replace: true });
        } catch (error) {
            toast.error(error.message || "An error occurred. Please try again.");
        }
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", backgroundColor: "#1B2A4A" }}>
            <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={11} sm={8} md={5} lg={3.5}>
                    <Box sx={{ backgroundColor: "#fff", borderRadius: "8px", p: { xs: 4, sm: 5 }, boxShadow: "0 4px 24px rgba(0,0,0,0.2)" }}>
                        <form onSubmit={handleClick}>
                            <Box sx={{ textAlign: "center", mb: 3.5 }}>
                                <Box sx={{ width: 44, height: 44, borderRadius: "8px", backgroundColor: "#0b5cab", mx: "auto", mb: 2, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "1.25rem" }}>B</Typography>
                                </Box>
                                <Typography sx={{ fontWeight: 700, fontSize: "1.25rem", color: "#1a2138" }}>Burgan Real Estate</Typography>
                                <Typography sx={{ fontSize: "0.8125rem", color: "#5a6a85", mt: 0.5 }}>Tenants Management System</Typography>
                            </Box>
                            <Stack spacing={2.5}>
                                <TextField name="email" label="Email address" value={formData.email} onChange={handelOnChange} fullWidth />
                                <TextField name="password" label="Password" type={showPassword ? "text" : "password"} value={formData.password} onChange={handelOnChange} fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" sx={{ color: "#5a6a85" }}>
                                                    {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Button fullWidth size="large" type="submit" variant="contained" color="primary"
                                    sx={{ py: 1.25, fontWeight: 600, fontSize: "0.875rem" }}
                                >
                                    Sign In
                                </Button>
                            </Stack>
                        </form>
                        <Typography sx={{ mt: 3, textAlign: "center", fontSize: "0.6875rem", color: "#8896a8" }}>
                            Powered by{" "}
                            <a href="https://smartflix.ae/" target="_blank" rel="noopener noreferrer"
                                style={{ color: "#a8cce8", textDecoration: "none", fontWeight: 600 }}
                            >
                                Smartflix Technologies
                            </a>
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Login;
